import auth0 from 'auth0-js'

import { getRedirectURL } from './auth'
import envConfig from './env-config'

class Auth0Auth {
  auth0 = new auth0.WebAuth({
    domain: envConfig.auth0.domain,
    clientID: envConfig.auth0.clientID,
    responseType: 'token id_token',
    scope: 'openid email'
  })

  login() {
    this.auth0.authorize({
      redirectUri: getRedirectURL()
    })
  }

  logout(returnTo: string) {
    this.auth0.logout({ returnTo })
  }

  parseToken(): Promise<string> {
    return new Promise((resolve, reject) => {
      this.auth0.parseHash(
        { hash: window.location.search },
        (err, authResult) => {
          if (err) {
            reject(err)
            return
          }
          if (authResult && authResult.accessToken && authResult.idToken) {
            resolve(authResult.idToken)
            return
          }
          reject(new Error('Failed to get token'))
        }
      )
    })
  }
}

const auth0Auth = new Auth0Auth()

export default auth0Auth
